<template>
  <b-container fluid>
    <AdminDetail :config="config"/>
  </b-container>
</template>

<script>
import AdminDetail from "@/components/Global/AdminDetail";
import config from "./config";

export default {
  name: "WarehouseDetail",
  components: {
    AdminDetail
  },
  data() {
    return {
      config: config
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Warehouse/WarehouseDetail.vue